import { parseJson } from '../../utils/Utils.js';

const GLB_MAGIC = 0x46546c67;
const GLB_JSON_CHUNK_TYPE = 0x4e4f534a;

interface GltfJsonMeshPrimitive {
  indices?: number;
}

interface GltfJsonRoot {
  meshes?: Array<{ primitives?: GltfJsonMeshPrimitive[] }>;
}

function parseGlbJsonChunk(buffer: ArrayBuffer): GltfJsonRoot {
  const view = new DataView(buffer);
  if (view.byteLength < 20) {
    throw new Error('GLB file too small');
  }
  if (view.getUint32(0, true) !== GLB_MAGIC) {
    throw new Error('Not a GLB file');
  }
  if (view.getUint32(4, true) !== 2) {
    throw new Error('Only GLB version 2 is supported');
  }
  if (view.getUint32(16, true) !== GLB_JSON_CHUNK_TYPE) {
    throw new Error('GLB JSON chunk not found');
  }

  const jsonChunkLength = view.getUint32(12, true);
  const jsonBytes = new Uint8Array(buffer, 20, jsonChunkLength);
  return parseJson(new TextDecoder().decode(jsonBytes)) as GltfJsonRoot;
}

/** True when the first mesh primitive declares a glTF `indices` accessor. */
export function glbSourceIndexedFromBuffer(buffer: ArrayBuffer): boolean {
  const gltf = parseGlbJsonChunk(buffer);
  const primitive = gltf.meshes?.[0]?.primitives?.[0];
  if (!primitive) {
    throw new Error('GLB has no mesh primitives');
  }
  return primitive.indices !== undefined;
}
